import { Group, TextProps } from "@mantine/core"
import type { CountryIso3166 } from "@tfg/db"
import { CountryLabel, Missing } from "@tfg/ui"

import { COUNTRIES } from "~/utils/countries.ts"

type Props = TextProps & {
  countryIso3166?: CountryIso3166 | null
  dimmed?: boolean
}

export const CountryCell = ({ countryIso3166, dimmed }: Props) => {
  if (!countryIso3166) return <Missing />

  const dimmedStyle = dimmed ? { filter: "grayscale(75%)" } : {}
  return (
    <Group style={{ whiteSpace: "nowrap", ...dimmedStyle }}>
      <CountryLabel
        countryIso3166={countryIso3166}
        countriesMapper={COUNTRIES}
      />
    </Group>
  )
}
